import { createContext, useState, useEffect, useMemo } from "react";
import { User } from "../services/UserService";
import {
  setUserPreferenceLocalStorage,
  getUserAuthLocalStorage,
  getAccessTokenLocalStorage,
  ValidAccessTokenLocalStorage,
  handleUserLogOutErro,
  seti18nextLngLocalStorage,
  setlangStorage,
  handleLanguageFormat,
  setAccessTokenLocalStorage,
} from "./utils";
import { HandleAudienceTime } from "../utils/audienceUtils";
import { IUserPreferenceContext } from "../utils/types";
import { getDecryptedCredentials } from "../utils/cryptoUtils";
import { LoginRequest } from "../services/UserAuthService";
import { DatePraca } from "../services/DateService";



export const UserPreferenceContext = createContext({} as IUserPreferenceContext);
const UserPreferenceProvider = ({ children }) => {
  useEffect(() => { }, []);

  const [userAuthenticated, setUserAuthenticated] = useState<boolean>(false);
  const [userPreference, setUserPreference] = useState<any>();
  const [horaIniCalendar, setHoraIniCalendar] = useState<string>();
  const [horaFinCalendar, setHoraFinCalendar] = useState<string>();
  const [userMenssageApi, setUserMenssageApi] = useState<string>();
  const [loaded, setLoaded] = useState<boolean>(false);
  const [minuteImage, setMinuteImage] = useState<number>(0);
  const [userTarget, setUserTarget] = useState<any>(null);

  function updateUserPreference(userData) {
    if (
      userData?.data !== null &&
      userData?.data !== undefined &&
      Number(userData?.data?.CodigoRetorno === 0) &&
      Number(userData?.data?.UserId > 0)
    ) {
      setUserPreference(userData.data);
      HandleAudienceTime(userData.data, setHoraIniCalendar, setHoraFinCalendar);
    }
  }

  function handleResponseDataUserPreference(res, userAuth) {
    if (
      res?.data !== undefined &&
      res?.data !== null &&
      Number(res?.data?.UserId > 0) &&
      userAuth?.username !== undefined
    ) {

      setUserPreference(res.data);

      setUserPreferenceLocalStorage(res.data, userAuth);
      seti18nextLngLocalStorage(
        handleLanguageFormat(res?.data?.Language?.IdiomaPrefixo)
      );
      setlangStorage(handleLanguageFormat(res?.data?.Language?.IdiomaPrefixo));
      if (!userAuthenticated) {
        setUserAuthenticated(true);
        setLoaded(true);
      }
      HandleAudienceTime(res.data, setHoraIniCalendar, setHoraFinCalendar);
    }
  }
  async function doUserPreference() {
    let token = getAccessTokenLocalStorage();
    let userAuth = getUserAuthLocalStorage();
    if (ValidAccessTokenLocalStorage()) {



      await User(token)
        .then(async (res) => {
          let userPreference = res.data;

          if (userPreference.ChangeAutoUpdate) {
            userPreference = await UpdateDateTimeUser(token, userPreference);
          }

          setUserPreference(userPreference);
          handleResponseDataUserPreference(res, userAuth);

        })
        .catch((err) => {
          handleReturnWithWError401(
            err,
            userAuthenticated,
            setUserAuthenticated,
            setUserMenssageApi,
            async (newToken?: string) => {

              const tokenToUse = newToken || getAccessTokenLocalStorage();
              const newUserAuth = getUserAuthLocalStorage();
              const res = await User(tokenToUse);
              setUserPreference(res.data);
              handleResponseDataUserPreference(res, newUserAuth);
            }
          );
        });
    }
  }
  async function UpdateDateTimeUser(token, userPreference) {
    await DatePraca(token || "", userPreference.Country.CountryID, userPreference.Praca.Id).then(res => {
      if (res.status === 200) {
        let datetime = res.data;
        userPreference.Horario = datetime;

        // Ajusta Data e HorarioIni para o mesmo dia retornado em Horario
        const newDate = datetime.split('T')[0] || "";
        userPreference.Data = `${newDate}T00:00:00` || "";

        const currentTimeHoraIni = userPreference.HorarioIni.split('T')[1] || "";
        userPreference.HorarioIni = `${newDate}T${currentTimeHoraIni}` || "";
      }
    });
    return userPreference;
  }
  async function userPost(userPreference: any) {
    if (ValidAccessTokenLocalStorage()) {
      setUserTarget(userPreference);
    }
  }

  const objMemoProvider = useMemo<IUserPreferenceContext>(
    () => ({
      userPreference,
      doUserPreference,
      userPost,
      userTarget,
      updateUserPreference,
      userAuthenticated,
      setUserAuthenticated,
      horaIniCalendar,
      horaFinCalendar,
      setHoraIniCalendar,
      setHoraFinCalendar,
      userMenssageApi, setUserMenssageApi,
      loaded, setLoaded,
      minuteImage, setMinuteImage,
      setUserPreference, setUserTarget
    }),
    [userPreference, userAuthenticated, horaIniCalendar, horaFinCalendar, userMenssageApi, loaded, minuteImage, userTarget]
  );
  return (
    <UserPreferenceContext.Provider value={objMemoProvider}>
      {children}
    </UserPreferenceContext.Provider>
  );
};

export default UserPreferenceProvider;

async function handleReturnWithWError401(
  resultError,
  userAuthenticated,
  setUserAuthenticated,
  setUserMenssageApi,
  retryCallback?: (newToken?: string) => Promise<void>
) {
  if (Number(resultError?.response?.status) === 401) {
    const savedCredentials = getDecryptedCredentials();
    if (savedCredentials && retryCallback) {
      try {
        const loginResult = await LoginRequest(
          savedCredentials.username,
          savedCredentials.password,
          savedCredentials.countryId,
          savedCredentials.language
        );
        if (loginResult && loginResult.access_token) {
          setAccessTokenLocalStorage(loginResult.access_token);
          const userAuth = {
            username: savedCredentials.username
          };
          localStorage.setItem('userAuth', JSON.stringify(userAuth));
          try {
            await retryCallback(loginResult.access_token);
            return;
          } catch (retryError) {
            return;
          }
        }
      } catch (loginError) {
        return;
      }
    }
  }


  handleUserLogOutErro(resultError, userAuthenticated, setUserAuthenticated, setUserMenssageApi);
}
